import styled from 'styled-components';

export const Inputs = styled.div`
  flex: 0 0 auto;
  margin-bottom: 28px;
  min-width: 0;
  width: 100%;
`;

export const HelperText = styled.div`
  font-size: 13px;
  line-height: ${16 / 13};
  margin-top: 8px;
  max-width: 310px;
  width: 100%;
`;

export const Input = styled.div`
  margin-bottom: 20px;
`;

export const Heading = styled.h2`
  color: #454e50;
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 8px;
`;

export const Label = styled.label`
  color: #454e50;
  cursor: pointer;
  display: block;
  font-weight: bold;
`;

export const SubText = styled.p`
  color: #4f5d68;
  font-size: 13px;
  line-height: 21px;
  max-width: 510px;
  overflow-wrap: break-word;
  padding-bottom: 16px;
  width: 80%;
`;
